/* eslint-disable react/forbid-dom-props */
import React from 'react'

export const LeaderboardIcon: React.FC<{ fill?: string }> = ({
  fill = '#BCB1B0',
}) => (
  <svg width="24" height="24">
    <g fill="none" fillRule="evenodd">
      <path d="M1 1h24v24H1z" />
      <path
        fill={fill}
        d="M16.011 20.025l-2.13 2.852a1 1 0 01-1.613-.014l-2.08-2.89-3.523.511a1 1 0 01-1.131-1.15l.573-3.514-2.853-2.13a1.001 1.001 0 01.014-1.613l2.89-2.08-.511-3.523a1 1 0 011.15-1.131l3.514.573 2.13-2.853a1.001 1.001 0 011.613.014l2.08 2.89 3.523-.511a1 1 0 011.131 1.15l-.572 3.514 2.852 2.13a1 1 0 01-.014 1.613l-2.89 2.08.511 3.523a1 1 0 01-1.15 1.131l-3.514-.572z"
      />
    </g>
  </svg>
)
